export default __webpack_public_path__ + "static/media/safe-recommendations--tablet.cf4ae1b8.webp";